module.exports = __webpack_public_path__ + "img/send.a3b2bc99.svg";